import Card from '@/components/Card';
import Stack from '@/components/Stack';
import { Body, Small } from '@/components/Typography';
import { WorkerCertificate } from '@/services/workersV2API';

type Props = {
  certificates: WorkerCertificate[];
};

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

const CertificatesCard = ({ certificates }: Props) => {
  if (!certificates || certificates.length === 0) {
    return (
      <Card title="Certificates (0)">
        <Card.Section>
          <Stack style={{ justifyContent: 'center', padding: '20px' }}>
            <Small color="lighter">No certificates found</Small>
          </Stack>
        </Card.Section>
      </Card>
    );
  }

  return (
    <Card title={`Certificates (${certificates.length})`}>
      {certificates.map((cert) => (
        <Card.Section key={cert.id}>
          <Stack gap={16} style={{ alignItems: 'flex-start' }}>
            {cert.image_url && (
              <div
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  flexShrink: 0,
                  backgroundColor: '#F3F4F6',
                }}
              >
                <img
                  src={cert.image_url}
                  alt={cert.certificate_name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            )}
            <Stack vertical gap={8} style={{ flex: 1 }}>
              <Body weight="semibold">{cert.certificate_name}</Body>
              {cert.certificate_description && (
                <Small color="lighter">{cert.certificate_description}</Small>
              )}
              <Small color="lighter">
                Added on {formatDate(cert.created_at)}
              </Small>
            </Stack>
          </Stack>
        </Card.Section>
      ))}
    </Card>
  );
};

export default CertificatesCard;
